angular.module('rjmNg.directives').directive "pathSettings", [
  () ->
    restrict: "E"
    templateUrl: "directive.pathSettings.html"
    replace: false
    scope: {}
    controllerAs: "view"
    bindToController: true
    controller: [
      () ->
        view = @
        view.editingPath = false

        view
    ]
]
